import React,{useEffect, useState} from 'react'
import './style.css'
import data from '../../../constant/data.json';
import { Spider3d } from '../components/spidermodel';
import { useParallax,Parallax } from 'react-scroll-parallax';


const nameTexts = [
    {
        color:"#FFB704",
        top:500, //130
    },
    {
        color:"#FFBF20",
        top:630,
    },
    {
        color:"#FFC73C",
        top:760,
    },
    {
        color:"#FFCF57",
        top:890,
    },
    {
        color:"#FFD773",
        top:1020,
    },
    {
        color:"#FFDF8F",
        top:1150,
    },{
        color:"#FFE7AB",
        top:1280,
    },{
        color:"#FFEFC7",
        top:1410,
    },{
        color:"#FFF7E3",
        top:1540,
    },
    
        ];
export default function NameSection(props) {
    // const [isSticky,setIsSticky] = useState(true);
   

   
    const parallaxBack = useParallax({
        speed: -60,
        });

    return (
            <div className='name-sec-main'>
                      {/* <Spider3d axisY={axisY} /> */}
                      {/* <div style={{
                        flex:1,
                        position: 'relative',
                        paddingTop:200
                      }}> */}
                      <p className='name-iam-text'>I A M</p>
                    <p className='name-name-text'>{data.name}</p>
                    {nameTexts.map(item =>{
                        return <p style={{color:item.color,position:"absolute",left:0,right:0,top:item.top - 30}} className='name-name-text textShadow'>{data.name}</p>
                    })}
                    <div style={{
                        position:"absolute",
                        top:200,
                        // zIndex:100,
                        width:'100%',
                        height:300
                    }} ref={parallaxBack.ref}>
                    <img   className='name-uiux-img' src={require("../../../assets/images/uiux.png")} /> 
                    <img  className='name-graphicdesign-img' src={require("../../../assets/images/graphicsdesigner.png")} /> 
                    <img style={{}} className='name-photographer-img' src={require("../../../assets/images/photographer.png")} /> 
                    </div>
                    
                    <div style={{
                        //   position:isSticky?"fixed":"absolute",
                          position:"sticky",
                        //   top:isSticky?500:1765,
                          top:465,
                        
                    }} className='name-white-container'>
                      <p style={{color:"#FFF"}} className='name-name-text'>{data.name}</p>
                    </div>
                      {/* </div> */}
                    

                  
        </div>
    )
}
